import { render, staticRenderFns } from "./FansDeal.vue?vue&type=template&id=3eea5038&scoped=true&"
import script from "./FansDeal.vue?vue&type=script&lang=js&"
export * from "./FansDeal.vue?vue&type=script&lang=js&"
import style0 from "./FansDeal.vue?vue&type=style&index=0&id=3eea5038&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eea5038",
  null
  
)

export default component.exports